import validate from "/app/node_modules/.pnpm/nuxt@3.17.7_@biomejs+biome@2.1.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_88be7e189f510fd1a34e043878e3e59d/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.7_@biomejs+biome@2.1.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_88be7e189f510fd1a34e043878e3e59d/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}